import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'

const enum PageIdWoofz22V9 {
  DOG_AGE_V9 = PageId.DOG_AGE_V9,
  URGE_V9 = PageId.URGE_V9,
  URGE_2_V9 = PageId.URGE_2_V9,
  DOG_STATISTICS_V9 = PageId.DOG_STATISTICS_V9,
  EMAIL_V9 = PageId.EMAIL_V9,
  CONGRATS_V9 = PageId.CONGRATS_V9,
  SEX_V9 = PageId.SEX_V9,
  DOG_BREED_V9 = PageId.DOG_BREED_V9,
  DOG_BREED_ID_V9 = PageId.DOG_BREED_ID_V9,
  COMMANDS_61_V9 = PageId.COMMANDS_61_V9,
  COMMANDS_62_V9 = PageId.COMMANDS_62_V9,
  COMMANDS_63_V9 = PageId.COMMANDS_63_V9,
  COMMANDS_64_V9 = PageId.COMMANDS_64_V9,
  POTTY_V9 = PageId.POTTY_V9,
  BEHAVIOR_V9 = PageId.BEHAVIOR_V9,
  TRAINING_V9 = PageId.TRAINING_V9,
  PREPARE_FLOW_V9 = PageId.PREPARE_FLOW_V9,
  SUBSCRIPTIONS_V9 = PageId.SUBSCRIPTIONS_V9,
  CANCEL_OFFER_V9 = PageId.CANCEL_OFFER_V9,
  CHAT_UPSELL_V9 = PageId.CHAT_UPSELL_V9,
  UPSELL_V9 = PageId.UPSELL_V9,
  UPSELL_PITPAT_V9 = PageId.UPSELL_PITPAT_V9,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_V9 = PageId.DOWNLOAD_V9,
}

type TIdToPageMapWoofz22V9 = Record<PageIdWoofz22V9, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ22V9: TIdToPageMapWoofz22V9 = {
  dog_age_v9: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v9/pages/questions/DogAgeQuestion').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v9/pages/questions/DogAgeQuestion'),
  },
  urge_v9: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v9/pages/questions/UrgePage').then((m) => ({
        default: m.UrgePageVariantV9,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v9/pages/questions/UrgePage'),
  },
  urge_2_v9: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/UrgePageVariant2Version2'
      ).then((m) => ({
        default: m.UrgePageVariant2Version2V9,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/UrgePageVariant2Version2'
      ),
  },
  dog_statistics_v9: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/dog-statistics/DogStatistics'
      ).then((m) => ({
        default: m.DogStatistics22V9,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/dog-statistics/DogStatistics'
      ),
  },
  email_v9: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v9/pages/email/EmailV9').then((m) => ({
        default: m.EmailV9,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v9/pages/email/EmailV9'),
  },
  congrats_v9: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/CongratsPageSpinVersion'
      ).then((m) => ({
        default: m.CongratsPageSpinVersion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/CongratsPageSpinVersion'
      ),
  },
  sex_v9: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v9/pages/questions/SexV9').then((m) => ({
        default: m.SexV9,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v9/pages/questions/SexV9'),
  },
  dog_breed_v9: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedVariantV9,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  dog_breed_id_v9: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/dog-breed/breedId/BreedPhotoScreen'
      ).then((m) => ({
        default: m.BreedPhotoScreenVariantV9,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/dog-breed/breedId/BreedPhotoScreen'
      ),
  },
  commands_61_v9: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/commands/CommandsQuestionVariant61V9'
      ).then((m) => ({
        default: m.CommandsQuestionVariant61V9,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/commands/CommandsQuestionVariant61V9'
      ),
  },
  commands_62_v9: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/commands/CommandsQuestionVariant62V9'
      ).then((m) => ({
        default: m.CommandsQuestionVariant62V9,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/commands/CommandsQuestionVariant62V9'
      ),
  },
  commands_63_v9: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/commands/CommandsQuestionVariant63V9'
      ).then((m) => ({
        default: m.CommandsQuestionVariant63V9,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/commands/CommandsQuestionVariant63V9'
      ),
  },
  commands_64_v9: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/commands/CommandsQuestionVariant64V9'
      ).then((m) => ({
        default: m.CommandsQuestionVariant64V9,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/commands/CommandsQuestionVariant64V9'
      ),
  },
  potty_v9: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v9/pages/questions/PottyQuestion').then(
        (m) => ({
          default: m.PottyQuestionV9,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v9/pages/questions/PottyQuestion'),
  },
  behavior_v9: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v9/pages/questions/BehaviorQuestion').then(
        (m) => ({
          default: m.BehaviorQuestionV9,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v9/pages/questions/BehaviorQuestion'),
  },
  training_v9: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v9/pages/questions/TrainingQuestion').then(
        (m) => ({
          default: m.TrainingQuestionVariantV9,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v9/pages/questions/TrainingQuestion'),
  },
  prepare_flow_v9: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/prepare-flow/PrepareFlowV9'
      ).then((m) => ({
        default: m.PrepareFlowV9,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v9/pages/questions/prepare-flow/PrepareFlowV9'
      ),
  },
  subscriptions_v9: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v9/pages/subscriptions/SubscriptionsV9'
      ).then((m) => ({
        default: m.SubscriptionsV9,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v9/pages/subscriptions/SubscriptionsV9'),
  },
  cancel_offer_v9: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v9/pages/subscriptions/CancelOfferV9'
      ).then((m) => ({ default: m.CancelOfferV9 })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v9/pages/subscriptions/CancelOfferV9'),
  },
  chat_upsell_v9: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v9/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v9/pages/upsell/ChatUpsellNewFlow'),
  },
  upsell_v9: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v9/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v9/pages/upsell/Upsell'),
  },
  upsell_pitpat_v9: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v9/pages/upsell/PitPatUpsell').then(
        (m) => ({
          default: m.PitPatUpsell,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz22_v9/pages/upsell/PitPatUpsell'),
  },
  account_nove8: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  download_v9: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v9/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v9/pages/download-app/DownloadApp'),
  },
}
